export default {
  app: {
    notFound: {
      title: 'Sidan hittas inte.',
      subtitle: 'Det ser ut som om du har gått vilse.',
      text: 'Oroa dig inte, vi hjälper dig att navigera härifrån',
    },
  },
};
